export enum NavigationSteps{
    MedicalInformation = "MedicalInformation",
    Diagnoses = "Diagnoses",
    UnderlyingImpairments = "UnderlyingImpairments",
    FunctionalLimitations = "FunctionalLimitationsAndGGSections",
    FOMS = "FOMS",
    STGAndLTG = "STGAndLTGPage",
    TreatmentPlan = "TreatmentPlan",
    updatePOC = "UPOC"
}

export const documentation ={
    EPOC: "EPOC",
    DocumentType: "Evaluation & Plan of Care",
    DocumentDefaultStatus: "Draft",
    ReturnToDocumentation: "Documentation",
    ViewDocumentation: "View Documentation",
    DocumentComplete: 'Complete',
    ProgressReport: "Progress Report",
    DCProgressReport: "Discharge Report",
    RecertificationAndUpdatedPlanOfCare: "Recertification and Updated Plan of Care",
    EvaluationOnly: 'Evaluation Only',
    EvaluOnly: "Evaluation Only",
    DCReport: "Discharge Report",
    DCReportST: "Discharge Report-ST",
    selectAll: 'All',
    DCDoc: [
      "Discharge Report",
      "Discharge Report-ST"
    ],
    PRAndRCDoc: [
      "Progress Report",
      "Progress Report-ST",
      "Recertification and Updated Plan of Care",
      "Recertification and Updated Plan of Care-ST"
    ],
    OptionalSections: 'Optional Sections',
    optional: 'optional',
    functional_limitations: 'Functional_Limitations',
    gg_sections: 'GGSections',
  }

export const buttonTitles = {
    reFetch : "Re-fetch",
    save: "Save",
    cancel: "Cancel",
    ok: "Ok",
    confirmRefetch: "Confirm Re-fetch",
    EvaluationOnly: 'Evaluation Only'
}

export enum DocumentStatusNumber {
    NotInitiated = 1,
    InitiateOrDraft = 2,
    MissingCoSignature = 3,
    Complete = 4,
    SignatureNotSent = 5,
    SentForSignature = 6,
    SignatureRejected = 7,
    SignatureComplete = 8,
    UnavailableForSignature = 9,
}

    

export const DocumentIncomplete = {
    title : 'Document Incomplete',
    message : 'Please note that this document is incomplete and a DRAFT.',
    buttonText: buttonTitles.save,
}
    
export const DocumentComplete = {
    title : 'Finalize Documentation',
    message : 'You are about to finalize and lock this document. To make changes in the future, you will need to unlock the document before changes can be made.',
    buttonText: 'Finalize'
}


export const CharacterRestrictionError =  {
    title: "Error",
    message: "Please enter at least 3 characters to continue",
    buttonText: "OK",
}

export const ConfirmChanges = {
        title: "Confirm Changes",
        message: "Mandatory fields are not filled. Please let us know if you would like to save before navigating or cancel.",
        buttonText: buttonTitles.save,
}

export const EsignatureDocEditChanges = {
        title: "Confirm Edit",
        buttonText: "Yes",
}

export const CancelAndExit = {
    title: "Cancel & Exit",
    message: "You have chosen to cancel and exit the document <br><br> All work completed since opening this document will be canceled and removed. The document's information will revert to what was here prior to when you chose to edit.",
    buttonText: "Ok",
}

export const TransistionalPhysicanRequiredErrorObject = {
    error: {
        responseData: {
          error: "Required Field",  
          message: "Please select a physician from the dropdown to proceed with the transitional document.",  
        },
      },
    status: 400, 
}

export const IncompleteNavigationPopUp = {
    title: "Mandatory fields are not filled",
    message: "Mandatory fields are not filled. Please let us know if you would like to save before navigating or cancel.",
    buttonText: "Continue",
    hideCancelButton: false,
    isError: true,
}

export const evalOnlyConfirmationPopup = {
  title: 'Do you want to switch to Evaluation mode?',
  message: 'Plan of care sections will be available in read only mode as you selected for Evaluation only',
  hideCancelButton: false,
  buttonText: 'Ok',
  isError: false
}

export const  fillFields = "Please fill out all necessary fields";

const deleteMessage = "Are you sure you would like to delete this";

const successMessage = "saved successfully";

export const InvalidFieldsErrorMessage = "The steps you visited may have invalid fields. Please revisit the pages again";

export const MandatoryFieldsNavigationMessage = "Mandatory fields are not filled. Please let us know if you would like to save before navigating or cancel.";

export const DiagnosisFieldsNotFilled = `${fillFields} in Diagnosis section.`;

export const STGLTGFieldsNotFilled = `${fillFields} in STG and LTG.`;

export const CPTFieldsNotFilled = `${fillFields} in CPT codes.`;

export const DeleteConfirmationMessage =  "Are you sure you want to delete?";

export const FunctionalLimitationDeleteMessage = `${deleteMessage} functional limitation?`;

export const FunctionalLimitationSuccessMessage = `Functional Limitations ${successMessage}`;

export const FunctionalLimitationMandatoryMessage = "No Functional Limitations are added, this is a mandatory section.";

export const UnderlyingImpairmentDeleteMessage = `${deleteMessage} underlying impairment?`;

export const UnderlyingImpairmentSuccessMessage = `Underlying impairments ${successMessage}`;

export const VALID = "VALID";

export const Confirm = 'Confirm';

export const Close = 'close';

export const Ok = 'Ok';

export const maxTargetNumber = 13; //give 1 day less, Now here it works for 14days

export const skilledCareNarrativeMessage = 'At least one Short-Term Goal or one Long-Term Goal are required for Skilled Care or for completing this document. Please add goals to continue.';

export const minNumberOfCharactersForSearch = 3;

export const minCharactersForSearchErrorMessage = "Please provide atleast 3 characters to search";

export const maxCharactersForTextArea = 2048;

export const NarrativeDisclosureTooltipText = "This narrative, generated by (the AI resource) is intended to support clinical documentation workflow and is not intended to replace or direct the professional judgment of the Licensed Therapist. As the Licensed Therapist, You must review all entries to the clinical record to ensure they accurately reflect the clinical evidence in the record, the approved treatment plan, patient specific goals and the individual patient’s progress. Your signature as the Licensed Therapist is an attestation of the accuracy and completeness of the narrative documentation."

export const GOAL_TYPE = {
  STG: 'STG',
  LTG: 'LTG'
}
export const SubActivityText: string = "SubActivity";

export const additionToIndex = 1;

export const UnderScore = "_";

export const LoadedEvaluationOnly = 'LoadedEvaluationOnly';

export const EvaluationOnly = 'EvaluationOnly';

export const viewOnlyMode = 'viewOnlyMode';

export const EvalDate = 'EvalDate';

export const CommonCPTCodes = 'Common CPT Codes';

export const CommonErrorMessage = 'Something went wrong!'

export const FILTER_BY_ASSESSMENT_TYPE = "Filter by Assessment Type";

export const SELECT_ASSESSMENT_TYPE = "Select Assessment Type";

export const sectionIds = {
  Underlying: 'Underlying',
  Functional: 'Functional',
  TreatmentPlan: 'TreatmentPlan',
  cptcode: 'cptcode',
  Precautions: 'Precautions',
  EvalOnly: 'MedicalInformation_GeneralInformation_Main_EvaluationOnly',
  EvalDate: '_EvalDate',
  ClinicalAssessmentAndResponseToCare : 'ClinicalAssessmentAndResponseToCare',
  AssessmentOfPOCFromSOC : 'AssessmentOfPOCFromSOC'
};

export const disabledSectionNamesForEval = [
  "Underlying Impairments",
  "Functional Limitations(GGSection)",
  "Functional Limitations",
];

export const FORM_KEYS = {
  STEP_NUMBER: 'stepNumber',
  SECTION_NUMBER: 'sectionNumber',
  SELECTED_CPT_CODES: 'selectedCPTCodes',
  CURRENT_PARENT_PAGE: 'currentParentPage',
  EVAL_DATE: 'EvalDate',
  CERTIFICATION_FROM_DATE: 'CertificationFromDate',
  CERTIFICATION_TO_DATE: 'CertificationToDate',
  VIEW_GOALS: 'View Goals',
  DOC_DISCIPLINE_ID: 'docDisciplineId',
  PATIENT_DOCUMENT_ID: 'patientDocumentId'
};

export const GRID_ACTIONS = {
  DELETE: 'Delete',
  EDIT: 'Edit',
  VIEW: 'View',
  ADD_NEW: 'Add New',
  VIEW_NEW: 'View New',
  ADD: 'Add',
};

export const FUNCTIONAL_LIMITATIONS = {
  VIEW: 'View Functional Limitations',
  ADD: 'Add Functional Limitations',
};

export const OPTIONAL_SECTION = {
  ADD: 'Add Optional',
  VIEW: 'View Optional',
};

export const SHORT_LONG_TERM_GOALS = {
  ADD: 'Add Short & Long Term goal',
  VIEW: 'View Short & Long Term goal',
  EDIT: 'Edit Short & Long Term goal',
};

export const UNDERLYING_IMPAIRMENTS = {
  ADD: 'Add Underlying Impairments',
  VIEW: 'View Underlying Impairments',
  EDIT: 'Edit Underlying Impairments',
  ShortTermGoals: "Short Term Goals",
  LongTermGoals: "Long Term Goals"
};

export const UNDERLYING_IMPAIRMENTS_TEXT_SELECT_ERRORS = {
  Required: "Required",
  NumericValueRequired: "Numeric value is required.",
  MinimumAllowedValue: (minimumValue: number) => `Minimum allowed value is ${minimumValue}.`,
  MaximumAllowedValue: (maximumValue: number) => `Maximum allowed value is ${maximumValue}.`,
  ValueMustBeBetween: (minimumValue: number, maximumValue: number) => `Value must be between ${minimumValue} and ${maximumValue}.`
};

export const CPT_CODES = {
  VIEW: 'View CPT Codes',
  effectivestartdate: 'effectivestartdate'
};

export const COMMON = {
  PLAIN_TEXT_ONLY: 'plaintext-only',
};

export const BOOLEAN_STRING = {
    false: 'false',
    true: 'true',
};

export const OVERLAY_ADD_AND_UPDATE_TITLES = [
  'Add Goals',
  'Add STG',
  'Add LTG',
  'Update Goals',
  'Add Short & Long Term goal',
  'Edit Short & Long Term goal',
  'Update STG',
  'Update LTG',
  'View Short & Long Term goal',
];

export const SUBACTIVITY_TITLES = {
  CurrentFunction: 'Current Function',
  AdmissionPerformance: 'Admission Performance',
  DischargePerformance: 'Discharge Performance',
  Score: 'Score',
  AssessmentDate: 'Assessment Date',
  ShortTermStatus: 'Short Term Goal Status',
  LongTermStatus: 'Long Term Goal Status'
}

export const QuestionType = {
  Date: 'Date',
  TextArea: 'TextArea'
}

export const SUBACTIVITY_TYPES = {
  checkbox: 'Checkbox'
}

export const evalCPTCodesMessage = "You can add only one cpt code in Evaluation only mode. Delete the existing and try to add any other cpt code";

export const deleteWarningText = "The EPOC document has already been initiated. If you proceed, all progress made on this document will be lost and the Therapy Episode will be Deleted.";

export const disabledCPTCodesMessage = "Add cpt codes is not allowed";

export const ClinicalSummationsOfFindingsEvaluationOnlyIdentifer = "_ClinicalSummationofFindings_EvaluationOnly";

export const DisabledSectionIdsForEvalutionOnly = {
  UnderlyingImpairments : "UnderlyingImpairments_UnderlyingImpairments",
  FunctionalLimitations : "FunctionalLimitationsAndGGSections_FunctionalLimitations",
  FunctionalLimitationsMain : "FunctionalLimitationsAndGGSections_FunctionalLimitations_Main",
  GGSectionsIdentifier : "FunctionalLimitationsAndGGSections_",
  CPTCode : "TreatmentPlan_CPTCode",
}

export const Goals = {
  shortTermGoals : "FunctionalLimitationsAndGGSections_FunctionalLimitations_Main_ShortTermGoal",
  longTermGoals : "FunctionalLimitationsAndGGSections_FunctionalLimitations_Main_LongTermGoal"
}

export const getEvalOnlyDocName = (discipline: string) => {
  return 'Evaluation Only (' + discipline + ')'
}

export const getEvalAndPOCDocName = (discipline: string) => {
  return 'Evaluation & Plan of Care (' + discipline + ')'
}

export const PLAINTEXT_ONLY_VALUE: string = 'contenteditable="plaintext-only"';

export const CONTENT_EDITABLE_FALSE_VALUE: string = 'contenteditable="false"';

export const sessionStoreVariables = {
  selectedTherapySoc : "selectedTherapySOCDate",
}

export const GG_ACTIVITY_IDS = ['GG0100', 'GG0115', 'GG0110'];

export const LastTherapyBillingDate = "Last therapy billing date";

export const DCWarningData = {
    header: "Save Action Not Allowed",
    message1: "Discharge document activity does not match last billing date. To save the document, please make sure",
    message2: "Activity Date = Last Billing Date",
    confirmMessage: "I confirm the update of the Activity Date to the Billing Date.",
};

export const refetchSections = {
  otherSectionMappings: 'otherSectionMappings',
  impairmentsSectionMappings: 'impairmentsSectionMappings',
  upocSectionMappings: 'upocSectionMappings'
}

export const Comments = {
    requiredComments : "Comments are required"
}

export const Compose = "Compose";
export class SessionStorage {
  static readonly USER_KEY = 'user';
}

export class ErrorHandling {
  public static getErrorMessage(error: any): string {
    if (error.responseCode === '500') {
      return error.responseData || 'Internal server error';
    }
  
    if (error.responseCode === '400') {
      return error.responseData?.message || error.responseMessage || 'Bad request';
    }
  
    return error.responseMessage || 'An error occurred';
  }
}

export const parameterTypes = {
  Object: 'Object'
}

export const EditConfirmationMessageAfterSignature : string = "The document is currently locked and has been sent for signature. Proceeding with this action will unlock the document for editing. Are you sure you want to continue?";
export const EditConfirmationMessageAfterSignatureComplete : string = "The document is already in signature complete state. Proceeding with this action will unlock the document for editing. Are you sure you want to continue?";

export const ConfirmDocumentData = {
  title: "Confirm Document Edit",
  buttonText: "Yes",
  cancelText: "No"
};

export const PermissionDeniedDate = {
  title: "Permission Denied",
  message: "You do not have the required permissions to edit this document.",
  buttonText: "OK",
};

export const QuestionIds = {
  SkilledCareAndAssessment_SkilledCare_Main_EnhancedTag : 'SkilledCareAndAssessment_SkilledCare_Main_PurposeOfTreatment',
  SkilledCareAndAssessment_SkilledCare_Main_NewApproachesForFocus : "SkilledCareAndAssessment_SkilledCare_Main_NewApproachesForFocus",
  MedicalInformation_DischargeEnvironmentalAndPlan_Main : 'MedicalInformation_DischargeEnvironmentalAndPlan_Main_',
  MedicalInformation_DischargeEnvironmentalAndPlan_Main_ReturnToTheirPriorResidence: 'MedicalInformation_DischargeEnvironmentalAndPlan_Main_ReturnToTheirPriorResidence',
  MedicalInformation_PriorResidenceDMEUse_NursingHome_TypeSummary: 'MedicalInformation_PriorResidenceDMEUse_NursingHome_TypeSummary',
  CMHAndDCPlan_PatientOrCaregiverEducationOrTraining_Main_WasTherePatientTrainingThisPeriod : 'CMHAndDCPlan_PatientOrCaregiverEducationOrTraining_Main_WasTherePatientTrainingThisPeriod',
  SkilledCare_Main_FocusOfActivities : 'SkilledCareAndAssessment_SkilledCare_Main_FocusOfActivities',
  SkilledCare_Main_NewApproachesForFocus : 'SkilledCareAndAssessment_SkilledCare_Main_NewApproachesForFocus',
  PurposeOfTreatmentValues : 'PurposeOfTreatmentValues',
  EPOCCertificationFromDate: 'TreatmentPlan_CertificationDates_Main_CertificationFrom',
  UpdatedPOCCerttificationFromDate: 'UPOC_CertificationDates_Main_CertificationFrom'
};

export const SectionIds = {
  MedicalInformation_DischargeEnvironmentalAndPlan: 'MedicalInformation_DischargeEnvironmentalAndPlan',
  SkilledCareAndAssessment_SkilledCare : 'SkilledCareAndAssessment_SkilledCare',
  SkilledCareAndAssessment_SkilledTherapyProvided: 'SkilledCareAndAssessment_SkilledTherapyProvided',
  FunctionalLimitationsAndGGSections_OptionalSection: 'FunctionalLimitationsAndGGSections_OptionalSection',
  FunctionalLimitationsAndGGSections_FunctionalLimitations: 'FunctionalLimitationsAndGGSections_FunctionalLimitations' 
}

export const SummaryPlaceholders = {
  UserDiscipline: 'userDiscipline',
  Discipline: 'discipline',
  DisciplineTitle: 'disciplineTitle',
  QuestionId: 'QuestionId:',
  Endpoint: 'Endpoint'
};

export const CustomGoalConfiguration = {
    STG_GOAL_ID: 2147483646,
    LTG_GOAL_ID: 2147483647,
    MIN_LENGTH: 10,
    CONTROL_NAME: "customGoal",
    LABEL: "Custom Goal",
};

export const DocumentationSettingsUpdateError = "Unable to update Documentation settings.";
